/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { HealthFindrStrictHttpResponse } from '../../health-findr-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CommunicationBlobRequestModel } from '../../models/communication-blob-request-model';

export interface AnonymousCommunicationBlobContentIdPost$Params {
      body?: CommunicationBlobRequestModel
}

export function anonymousCommunicationBlobContentIdPost(http: HttpClient, rootUrl: string, params?: AnonymousCommunicationBlobContentIdPost$Params, context?: HttpContext): Observable<HealthFindrStrictHttpResponse<string>> {
  const rb = new RequestBuilder(rootUrl, anonymousCommunicationBlobContentIdPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as HealthFindrStrictHttpResponse<string>;
    })
  );
}

anonymousCommunicationBlobContentIdPost.PATH = '/Anonymous/CommunicationBlobContentId';
